import { render, staticRenderFns } from "./ClientesCard.vue?vue&type=template&id=0a1e47ec&"
import script from "./ClientesCard.vue?vue&type=script&lang=js&"
export * from "./ClientesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports